<template>
  <div v-if="type === 'select' && options" class="material-select material-input is-focus position-relative"
       :class="classes">
    <label class="position-absolute" v-html="label" :for="setId"></label>
    <select v-if="options"
            :id="setId"
            :name="name"
            class="text-truncate form-control position-relative material bg-transparent border-left-0 border-top-0 border-right-0 shadow-none rounded-0 py-2 pl-0 pr-4 w-100"
            @input="$emit('input', $event.target.value)"
            :class="{'d-none': !isMobile }"
            :autocomplete="autocomplete"
    >
      <option :value="defaultValue" v-html="mobileOptionLabel(setSelectDefaultLabel)" disabled :selected="!value"></option>
      <option v-for="option in options" :value="option.value" v-html="mobileOptionLabel(option.name)"
              :selected="option.value === value"></option>
    </select>

    <div class="tool__select position-relative"
         v-if="!isMobile"
         :class="{
          'tool__select--active': isOpen,
          'tool__select--inactive': !isOpen,
        }"
    >
      <button v-on:click.prevent="toggleSelect"
              class="text-truncate form-control position-relative material bg-transparent border-left-0 border-top-0 border-right-0 shadow-none rounded-0 py-2 pl-0 pr-4 w-100"
              v-html="setLabel(setSelectDefaultLabel, value, options)"></button>

      <div class="tool__select-wrapper position-relative position-sm-absolute w-100 shadow-sm">

        <ul class="tool__select-items bg-white m-0 d-block">
          <li v-if="value">
            <input type="radio"
                   :id="`tool__select-input-${setId}-default`"
                   :value="defaultValue"
                   @click="toggleSelect"
                   :selected="!value">
            <label :for="`tool__select-input-${setId}-default`"
                   class="d-block w-100"
                   v-html="setSelectDefaultLabel"></label>
          </li>
          <li v-for="(option, index) in options" :class="{'active': option.value === value}">
            <input type="radio"
                   :id="`tool__select-input-${setId}-${index}`"
                   :value="option.value"
                   :selected="option.value === value"
                   @click="toggleSelect"
                   :autocomplete="autocomplete"
            >
            <label class="d-block w-100"
                   :for="`tool__select-input-${setId}-${index}`"
                   v-html="option.name"></label>
          </li>
        </ul>
      </div>
    </div>


  </div>
  <div class="material-input animated position-relative" :class="[classes, {'is-focus': value}]"
       v-else-if="type !== 'select'">
    <label class="position-absolute" v-html="label" :for="setId"></label>
    <input
      class="text-truncate form-control position-relative material border-left-0 border-top-0 border-right-0 shadow-none rounded-0 py-2 px-1 w-100"
      :type="type"
      :disabled="disabled"
      :required="required"
      :pattern="pattern"
      :id="setId"
      :name="name"
      :value="value"
      :autocomplete="autocomplete"
      :inputmode="inputMode"
      @input="$emit('input', $event.target.value)"
    />

    <span class="error-message small position-absolute" v-if="errorMessage" v-html="errorMessage"></span>
  </div>
</template>

<script>

export default {
  name: 'toolforminput',
  props: {
    type: {
      type: String,
      required: true,
      default: 'text'
    },
    name: {
      type: String,
      required: true,
    },
    autocomplete: {
      type: String,
      required: false,
      default: null
    },
    id: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    pattern: {
      type: String,
      required: false,
      default: null
    },
    classes: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: [Number, String],
      required: false,
    },
    errorMessage: {
      type: String,
      required: false,
      default: ''
    },
    defaultOptionLabel: {
      type: String,
      required: false,
      default: 'Select a %s'
    },
    defaultOptionValue: {
      type: [Number, String],
      required: false,
      default: null
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    returnAs: {
      type: String,
      required: false,
      default: 'string'
    }
  },

  data() {
    return {
      isOpen: false,
    }
  },

  computed: {

    defaultValue() {
      return this.returnAs === 'number' ? 0 : '';
    },

    /**
     * Set ID of input
     * @returns {string}
     */
    setId() {
      return this.id || this.name;
    },

    /**
     * Set default label
     * @returns {string}
     */
    setSelectDefaultLabel() {
      return this.defaultOptionLabel.replace('%s', this.label.toLowerCase())
    },


    /**
     * Forcing mobile devices keyboard to specific keyboard based on type
     */
    inputMode() {
      if(this.type === 'number') {
        return 'nummeric';
      }

      if(this.type === 'tel') {
        return 'tel';
      }

      if(this.type === 'email'){
        return 'email';
      }

      return null;
    }
  },

  methods: {
    /**
     * Return label of option
     * @return {String}
     */
    setLabel(label, value, options) {

      if (value && options) {

        let filtered = options.filter(function(option) {
          return option.value === value;
        });

        return filtered[0].name;
      }
      return label;
    },


    /**
     * Toggle fake select
     * @param event
     */
    toggleSelect: function (event) {

      if('INPUT' === event.target.nodeName) {
        this.$emit('input', event.target.value);
      }

      this.isOpen = !this.isOpen;
    },

    /**
     * No HTML tags are supported in <option>
     * @param label
     */
    mobileOptionLabel(label) {
      return label.replace('<sup>', '&sup').replace('</sup>', ';');;
    }
  }


}
</script>
